import { render, staticRenderFns } from "./prizesList.vue?vue&type=template&id=75faf214&scoped=true"
import script from "./prizesList.vue?vue&type=script&lang=js"
export * from "./prizesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75faf214",
  null
  
)

export default component.exports